export default function ElitePrimeTabPlanSwitcherIcon() {
  return (
    <svg
      width='87'
      height='13'
      viewBox='0 0 87 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <g filter='url(#filter0_i_elite_prime_tab)'>
        <path
          d='M12.9062 12.7285H10.7578V0.213867H12.9062V12.7285ZM23.1934 3.94434H25.6104V5.74219H23.2441V9.38965C23.2442 9.86186 23.3834 10.2251 23.6631 10.4785C23.9429 10.7205 24.3407 10.8408 24.8555 10.8408C25.2359 10.8408 25.6501 10.7832 26.0977 10.668V12.5176C25.6054 12.6558 25.0962 12.7256 24.5703 12.7256C23.3953 12.7256 22.5219 12.4082 21.9512 11.7744C21.3805 11.1406 21.0947 10.3279 21.0947 9.33691V5.74219H19.6348V3.94434H21.1621V1.33398H23.1934V3.94434ZM31.3525 3.7334C32.3259 3.73344 33.1426 3.92958 33.8027 4.32129C34.463 4.7131 34.9557 5.2488 35.2803 5.92871C35.6048 6.59707 35.7666 7.3461 35.7666 8.17578C35.7666 8.37169 35.7558 8.60819 35.7334 8.88477H28.9707C29.0018 9.43217 29.1506 9.87611 29.4219 10.2158C29.8471 10.7226 30.4848 10.9765 31.335 10.9766C31.8833 10.9766 32.3372 10.8664 32.6953 10.6475C33.0644 10.4286 33.3223 10.1524 33.4678 9.81836H35.6836C35.4821 10.7171 35.0174 11.4258 34.29 11.9443C33.5626 12.4629 32.5944 12.7217 31.3857 12.7217C29.9421 12.7217 28.812 12.3356 27.9951 11.5635C27.1782 10.7799 26.7695 9.66191 26.7695 8.20996C26.7696 7.28837 26.9541 6.49341 27.3232 5.8252C27.7037 5.14543 28.2409 4.62676 28.9346 4.26953C29.6284 3.91229 30.4349 3.7334 31.3525 3.7334ZM8.7627 2.49219H2.41699V5.1543H8.42676V7.16016H2.41699V10.4785H8.83008V12.5186H0V0.487305H8.7627V2.49219ZM18.001 12.5146H15.8525V3.94141H18.001V12.5146ZM31.3525 5.39258C30.5021 5.39258 29.8691 5.65751 29.4551 6.1875C29.1834 6.53532 29.0227 6.95085 28.9678 7.43262H33.6348C33.6348 6.84493 33.4395 6.36075 33.0479 5.98047C32.6562 5.58871 32.091 5.39263 31.3525 5.39258ZM17.1113 0C17.4581 4.72833e-05 17.743 0.121371 17.9668 0.363281C18.2017 0.593664 18.3192 0.887098 18.3193 1.24414V1.31348C18.3193 1.65919 18.2018 1.95331 17.9668 2.19531C17.7431 2.43712 17.458 2.55855 17.1113 2.55859H16.7422C16.3954 2.55859 16.1041 2.4432 15.8691 2.21289C15.6453 1.97089 15.5332 1.67072 15.5332 1.31348V1.24414C15.5333 0.887118 15.6454 0.593658 15.8691 0.363281C16.1042 0.12128 16.3953 0 16.7422 0H17.1113Z'
          style={{ fill: 'var(--ep-tab-glyph, url(#paint0_linear_elite_prime_tab))' }}
        />
      </g>
      <path
        d='M78.125 8.44614C78.125 6.06428 79.6701 3.89258 82.5446 3.89258C85.4551 3.89258 87.0001 5.95919 87.0001 8.11338C87.0001 8.37608 86.9822 8.74387 86.9642 8.90149H80.0473C80.227 10.4252 81.2331 11.3709 82.6704 11.3709C83.8561 11.3709 84.7005 10.828 84.9341 9.86475L86.7845 10.3201C86.2995 12.0189 84.7544 12.9997 82.6344 12.9997C79.7599 12.9997 78.125 10.828 78.125 8.44614ZM80.1372 7.44786H84.9161C84.7903 6.25693 83.9819 5.39876 82.5446 5.39876C81.305 5.39876 80.4246 6.13433 80.1372 7.44786Z'
        style={{ fill: 'var(--ep-tab-glyph, #D45C68)' }}
      />
      <path
        d='M62.6445 12.8596V4.03269H64.6028V5.52135C65.0879 4.5581 65.9502 3.89258 67.2618 3.89258C68.717 3.89258 69.759 4.50556 70.1363 5.64395C70.6214 4.68069 71.6993 3.89258 73.1186 3.89258C75.0589 3.89258 76.3165 5.11854 76.3165 6.90493V12.8596H74.3583V7.3778C74.3583 6.27444 73.7115 5.53887 72.5617 5.53887C71.2142 5.53887 70.4417 6.69477 70.4417 8.3936V12.8596H68.5014V7.3778C68.5014 6.27444 67.8726 5.53887 66.7228 5.53887C65.3753 5.53887 64.6028 6.71228 64.6028 8.3936V12.8596H62.6445Z'
        style={{ fill: 'var(--ep-tab-glyph, #D45C68)' }}
      />
      <path
        d='M58.3617 12.8593V4.03238H60.3199V12.8593H58.3617ZM58.0742 1.33527C58.0742 0.634722 58.6132 0.0917969 59.3318 0.0917969C60.0684 0.0917969 60.6254 0.634722 60.6254 1.33527C60.6254 2.0183 60.0684 2.56123 59.3318 2.56123C58.6132 2.56123 58.0742 2.0183 58.0742 1.33527Z'
        style={{ fill: 'var(--ep-tab-glyph, #D45C68)' }}
      />
      <path
        d='M56.8635 5.88914C56.5402 5.74903 56.109 5.67897 55.6958 5.67897C54.3663 5.67897 53.1985 6.83488 53.1985 9.56701V12.8596H51.2402V4.03269H53.1985V5.714C53.6836 4.66318 54.8693 3.89258 55.9652 3.89258C56.3066 3.89258 56.7018 3.94512 56.9713 4.0502L56.8635 5.88914Z'
        style={{ fill: 'var(--ep-tab-glyph, #D45C68)' }}
      />
      <path
        d='M40.627 12.8592V0.599609H45.5855C48.0828 0.599609 49.6997 2.03573 49.6997 4.25997C49.6997 6.48421 48.0828 7.92033 45.5855 7.92033H42.7469V12.8592H40.627ZM42.7469 6.13394H45.4418C46.7713 6.13394 47.5618 5.43339 47.5618 4.25997C47.5618 3.08655 46.7713 2.38601 45.4418 2.38601H42.7469V6.13394Z'
        style={{ fill: 'var(--ep-tab-glyph, #D45C68)' }}
      />
      <defs>
        <filter
          id='filter0_i_elite_prime_tab'
          x='0'
          y='0'
          width='35.7666'
          height='13.1572'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.428635' />
          <feGaussianBlur stdDeviation='1.50022' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.604849 0 0 0 0 0.604849 0 0 0 0 0.604849 0 0 0 0.25 0'
          />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_elite_prime_tab' />
        </filter>
        <linearGradient
          id='paint0_linear_elite_prime_tab'
          x1='-1.89567'
          y1='19.9445'
          x2='42.9751'
          y2='15.963'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#9F4A53' />
          <stop offset='1' stopColor='#E65766' />
        </linearGradient>
      </defs>
    </svg>
  )
}
